import * as React from 'react';
import Map from '~/components/Map';
import { MapPostEventWrapperRef } from '~/components/Map/MapPostEventWrapper';
import GeoJSON from 'geojson';
import { MapEvent } from '~/config/map';
import { observer } from 'mobx-react';
import { TMapPositionParams } from '@ixicare/resources';
import { Spinner } from '@ixicare/ui';
import { useStores } from '~store/utils';

/** Outdoor params gain a siteId injected by the caller; indoor ones already carry theirs. */
export type MapPositionParams = TMapPositionParams & { siteUuid?: string };

type TGeoMapPositionProps = {
  params?: MapPositionParams;
  type?: string;
  geofence?: GeoJSON.Feature<GeoJSON.Polygon>;
  animate?: boolean;
};

const GeoMapPosition: React.FC<TGeoMapPositionProps> = ({ params, type, geofence, animate }) => {
  const { sites: sitesStore } = useStores();
  const [isMapLoaded, setMapLoaded] = React.useState(false);
  const map = React.useRef<MapPostEventWrapperRef>(null);

  React.useEffect(() => {
    if (isMapLoaded && geofence) {
      map.current?.sendEvent(MapEvent.SetOutdoorPolygon, geofence);
    }
  }, [geofence, isMapLoaded]);

  React.useEffect(() => {
    if (!params) return;

    const siteUuid = params.siteUuid;
    if (siteUuid) {
      const site = sitesStore.sites.find((s) => s.uuid === siteUuid);
      if (site) {
        map?.current?.sendEvent(MapEvent.UpdateParams, { ...params, site, animate });
      }
    } else {
      map?.current?.sendEvent(MapEvent.UpdateParams, { ...params, animate });
    }
  }, [params]);

  return !params ? (
    <Spinner />
  ) : (
    <Map
      ref={map}
      onMapLoaded={() => setMapLoaded(true)}
      page="geo-map-position"
      type={type}
      animate={animate}
      {...params}
    />
  );
};

export default observer(GeoMapPosition);
